import { useSelector } from 'react-redux'

import { selectGpsUser } from '@/features/domain/user'

export function useCanEditGpsData() {
  const gpsUser = useSelector(selectGpsUser)
  return gpsUser ? gpsUser.role === 'org-admin' || gpsUser.role.startsWith('staff-') : true
}
